import { useCallback } from 'react';

import { useEffectOnce } from 'src/lib/hooks';
import { usePopups } from 'src/lib/popups';

import { CustomDialog } from './CustomDialog';

export const CUSTOM_DIALOG = Symbol('CUSTOM_DIALOG');

export const useCustomDialog = () => {
  const popups = usePopups();

  useEffectOnce(() => {
    popups.registerPopup(CUSTOM_DIALOG, CustomDialog);
  });

  const openCustomDialog = useCallback(
    ({ title, cancelLabel, submitLabel, children, onSubmit, onCancel, onClose }) => {
      popups.openPopup(CUSTOM_DIALOG, {
        title,
        cancelLabel,
        submitLabel,
        children,
        onSubmit,
        onCancel,
        onClose,
      });
    },
    [popups]
  );

  const closeCustomDialog = useCallback(() => {
    popups.closePopup(CUSTOM_DIALOG);
  }, [popups]);

  return { openCustomDialog, closeCustomDialog };
};
